import React from 'react';

import initReactApp from 'dpl/util/initReactApp';
import BreederProfileBreedNonstandardTooltip from 'dpl/components/BreederProfile/Index/BreederProfileBreedNonstandardTooltip/index.jsx';
import BreederProfileEmptyResultsContainer from 'dpl/containers/BreederProfile/Index/BreederProfileEmptyResultsContainer';
import BreederProfileSuggestedBreedsListContainer from 'dpl/containers/BreederProfile/Index/BreederProfileSuggestedBreedsListContainer';
import NewsletterFormContainer from 'dpl/containers/NewsletterFormContainer';
import PuppyResultsTabbedLayout from 'dpl/puppy_search_results/components/TabbedLayout';
import BreederResultsBreedDescription from 'dpl/breeder_search_results/components/BreedDescription';
import BreederResultsBreedDescriptionModal from 'dpl/breeder_search_results/components/BreedDescriptionModal';
import InitialInquiryQuiz from 'dpl/initial_inquiry/components/InitialInquiryQuiz';
import PuppyModal from 'dpl/dog_modals/puppy_modal/components/PuppyModal';
import ParentModal from 'dpl/dog_modals/parent_modal/components/ParentModal';
import LitterModal from 'dpl/dog_modals/litter_modal/components/LitterModal';
import { ConsumerAppDownloadBanner } from 'dpl/puppy_search_results/components/consumer_app_download/ConsumerAppDownloadBanner';
import {
  ANALYTICS_VIEWS,
  ANALYTICS_VIEW_FEATURE_LOCATIONS
} from 'dpl/constants/analytics';

initReactApp({
  BreederProfileBreedNonstandardTooltip,
  BreederProfileEmptyResultsContainer,
  BreederProfileSuggestedBreedsListContainer,
  ConsumerAppDownloadBanner: function aliasConsumerAppDownloadBanner() {
    return (
      <ConsumerAppDownloadBanner
        analytics={{
          view: ANALYTICS_VIEWS.SEARCH_RESULTS,
          view_feature_location: ANALYTICS_VIEW_FEATURE_LOCATIONS.STICKY_TOP
        }}
      />
    );
  },
  InitialInquiryQuiz,
  NewsletterFormContainer,
  PuppyResultsTabbedLayout,
  PuppyModal,
  ParentModal,
  LitterModal,
  BreederResultsBreedDescription,
  BreederResultsBreedDescriptionModal
});
